import { Injectable, Output, EventEmitter } from '@angular/core';

import { ReservationModel, UserModel } from './../models';
import { CalendarEvent } from 'angular-calendar';

@Injectable()
export class EventsService {
    @Output() addReservationEmitter = new EventEmitter();
    @Output() refreshCalEmitter = new EventEmitter();
    @Output() eventTimeActionEmitter: EventEmitter<CalendarEvent> = new EventEmitter();
    @Output() hourClickedEmitter: EventEmitter<Date> = new EventEmitter();

    @Output() addUserEmitter = new EventEmitter();
    @Output() refreshUsersEmitter = new EventEmitter();

    constructor() {

    }

    addReservation(date?: Date) {
        this.addReservationEmitter.emit(date);
    }

    refreshCal() {
        this.refreshCalEmitter.emit();
    }

    refreshUsers() {
        this.refreshUsersEmitter.emit();
    }

    eventTimeAction(updatedEvent: CalendarEvent) {
        this.eventTimeActionEmitter.emit(updatedEvent);
    }

    hourClicked(clickedDateTime: Date) {
        this.hourClickedEmitter.emit(clickedDateTime);
    }

    addUser(userid?: string) {
        this.addUserEmitter.emit(userid);
    }
}


// WEBPACK FOOTER //
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/app/services/events.service.ts